import React, { useState } from 'react';

const SessionContext = React.createContext({
    isLoggedIn: false,
    username: null,
    password: null,
    playing: false
});

export const SessionProvider = props => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [playing, setPlaying] = useState(false);

    const handlerUsername = (data) => {
        setUsername(data);
    }

    const handlerPassword = (data) => {
        setPassword(data);
    }

    const handlerPlaying = (data) => {
        setPlaying(data);
    }

    const loginHandler = () => {
        if (username != null && password != null) {
            if (username.length > 0 && password.length > 0) {
                setIsLoggedIn(true)
            } else {
                console.log('nope');
            }
        } else {
            console.log('nope');
        }
    }

    const logout = () => {
        setIsLoggedIn(false);
        setUsername(false);
        setPassword(false);
    }

    return (
        <SessionContext.Provider value={{
            isLoggedIn: isLoggedIn,
            username: username,
            password: password,
            playing: playing,
            handlerPlaying: handlerPlaying,
            handlerPassword: handlerPassword,
            handlerUsername: handlerUsername,
            loginHandler: loginHandler,
            logout: logout
        }}>
            {props.children}
        </SessionContext.Provider>
    )
}

export default SessionContext;
